<!-- 404页面 -->
<template>
  <div>
    <div class="top">
      <div>
        <img :src="logo"
             alt="再来人logo">
      </div>
    </div>
    <div class="content">
      <div class="img">
        <img :src="img"
             alt="">
      </div>
      <div class="btn-con">
        <Button type="primary"
                class="btn"
                @click="returnHome">返回首页 {{num}}s</Button>
      </div>
    </div>
    <div v-html="copyright" style="width: 100%;position:absolute;left: 50%;transform: translate(-50%, 0);bottom:20px;font-size: 12px;"></div>
    <!-- <div class="bottom">
      Copyright &copy; -2019 北京华来荣信息技术有限公司 京ICP备14042096号-1
    </div> -->
  </div>
</template>

<script>
import img from '@/assets/images/error/404.svg'
import logo from '@/assets/Logo.svg'
import { copyright } from '@/constant'
export default {
  name: 'error-404',
  components: {},
  data () {
    return {
      num: 5,
      img,
      logo,
      copyright
    }
  },
  computed: {},
  mounted () {
    let interval = setInterval(() => {
      if (!this.num) {
        clearInterval(interval)
        this.returnHome()
      } else {
        this.num--
      }
    }, 1000)
  },
  methods: {
    returnHome () {
      this.$router.push({
        name: 'home'
      })
    }
  }
}
</script>
<style lang='less' scoped>
.top {
  height: 60px;
  box-shadow: 0 0 4px 0 rgba(101, 137, 221, 0.25);
  background: #ffffff;
  margin-bottom: 40px;
  div {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  img {
    width: 160px;
  }
}
.btn-con {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-con {
  margin-top: 40px;
  background-color: #ffffff;
}
.btn {
  width: 120px;
  font-size: 14px;
  border-radius: 2px;
}
.bottom {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translate(-50%, 0);
  text-align: center;
}
.img {
  height: 400px;
  text-align: center;
  background-color: #124380;
  img {
    margin-top: 39px;
  }
}
</style>
